import { combineReducers, createStore, applyMiddleware } from "redux";
import mainReducer from "../reducers/reducer";
import { composeWithDevTools } from 'redux-devtools-extension';
const root = combineReducers({
    mainState: mainReducer,
});
const store = createStore(root, composeWithDevTools(
    applyMiddleware(),
    // other store enhancers if any
));
export default store;